<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="calibre_pb_0">
<span id="Page_ix" title="[ix]"></span>
<h2 class="nobreak" id="pgepubid00003">LIST OF ILLUSTRATIONS</h2>
</div>
<table class="calibre8" summary="">
<tbody class="calibre9"><tr class="calibre10"><td class="calibre13">Col. Washington was in the thickest of the fight (<span href="#/Text/Section0035#Page_278" title="Link target outside of Sample">278</span>)</td>
<td class="tdr"><a href="#/Text/Section0002"> <i class="calibre12">Frontispiece</i></a></td>
</tr>
<tr class="calibre10"><td class="tdr" colspan="2"><span class="small">PAGE</span></td>
</tr>
<tr class="calibre10"><td class="calibre13">Like a flash Turtle Foot was yanked backward</td>
<td class="tdr"><span href="#/Text/Section0010#p042" title="Link target outside of Sample">      42</span></td>
</tr>
<tr class="calibre10"><td class="calibre13">“Looking for a chance to ship, lad?”</td>
<td class="tdr"><span href="#/Text/Section0014#p086" title="Link target outside of Sample">      86</span></td>
</tr>
<tr class="calibre10"><td class="calibre13">An instant later the bear discovered them</td>
<td class="tdr"><span href="#/Text/Section0018#p126" title="Link target outside of Sample">      127</span></td>
</tr>
<tr class="calibre10"><td class="calibre13">“The white men are welcome to Nancoke”</td>
<td class="tdr"><span href="#/Text/Section0023#p168" title="Link target outside of Sample">      169</span></td>
</tr>
<tr class="calibre10"><td class="calibre13">“Stop, do not murder him!”</td>
<td class="tdr"><span href="#/Text/Section0028#p214" title="Link target outside of Sample">      215</span></td>
</tr>
<tr class="calibre10"><td class="calibre13">“Got it pretty bad,” said the surgeon</td>
<td class="tdr"><span href="#/Text/Section0032#p252" title="Link target outside of Sample">      252</span></td>
</tr>
<tr class="calibre10"><td class="calibre13">“Father!” was all Dave could say</td>
<td class="tdr"><span href="#/Text/Section0036#p292" title="Link target outside of Sample">      293</span></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0005.vue?54a3f278